var map = {
	"./app-store.png": 33,
	"./new-experience.png": 34,
	"./old-experience.png": 35,
	"./outlook.png": 36,
	"./phones.png": 37,
	"./play-store.png": 38,
	"./process.png": 39,
	"./screenshot1.png": 40,
	"./slack.png": 41,
	"./teams.png": 42
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97;


//////////////////
// WEBPACK FOOTER
// ./src/images/kudos ^\.\/.*$
// module id = 97
// module chunks = 0